/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './booking.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '../shared/ui/mobile-header/mobile-header.component.ngfactory';
import * as import4 from '../../../app/shared/ui/mobile-header/mobile-header.component';
import * as import5 from '@angular/router';
import * as import6 from '../../../app/booking-management/booking-header/booking-header.service';
import * as import7 from '../../../app/booking-management/booking.component';
import * as import8 from './booking-filter/booking-filter.component.ngfactory';
import * as import9 from '../../../app/booking-management/booking-filter/booking-filter.component';
import * as import10 from './booking-list/booking-list.component.ngfactory';
import * as import11 from '../../../app/booking-management/booking-list/booking-list.component';
import * as import12 from '../../../app/booking-management/booking-list/booking-list-multi-select.service';
import * as import13 from '@angular/material';
import * as import14 from '../../../app/api/booking.service';
import * as import15 from '../../../app/spinner/spinner.service';
import * as import16 from '../../../app/notification/notification.service';
import * as import17 from '../../../app/shared/role-permission/role-permission';
import * as import18 from '../../../app/shared/sub-organisation-filter/sub-organisation-filter.service';
const styles_BookingComponent:any[] = [import0.styles];
export const RenderType_BookingComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_BookingComponent,
  data: {}
}
);
function View_BookingComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),21,'nav',[[
        'id',
        'footer-mobile'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setActiveFilter('all')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),[' All '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setActiveFilter('allocated')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),[' Allocated '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setActiveFilter('open')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),[' Open '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.setActiveFilter('new_invites')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),[' New Invites '])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,4,0,co.isActiveFilter('all'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = ck(v,9,0,co.isActiveFilter('allocated'));
    ck(v,8,0,currVal_1);
    const currVal_2:any = ck(v,14,0,co.isActiveFilter('open'));
    ck(v,13,0,currVal_2);
    const currVal_3:any = ck(v,19,0,co.isActiveFilter('new_invites'));
    ck(v,18,0,currVal_3);
  },(null as any));
}
export function View_BookingComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-mobile-header',[[
        'title',
        'BOOKINGS'
      ]
    ],(null as any),(null as any),(null as any),import3.View_MobileHeaderComponent_0,import3.RenderType_MobileHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import4.MobileHeaderComponent,[
      import5.Router,
      import6.BookingHeaderService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      showBackLink: [
        1,
        'showBackLink'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'section',[
      [
        'class',
        'no-margin-mobile no-padding-mobile'
      ]
      ,
      [
        'id',
        'page-jobs'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-booking-filter',([] as any[]),(null as any),[[
        (null as any),
        'appBookingFilter'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import7.BookingComponent = v.component;
      if (('appBookingFilter' === en)) {
        const pd_0:any = ((<any>co.getPaginatedBooking()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_BookingFilterComponent_0,import8.RenderType_BookingFilterComponent)),
    import1.ɵdid(114688,(null as any),0,import9.BookingFilterComponent,([] as any[]),(null as any),{appBookingFilter: 'appBookingFilter'}),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(16777216,(null as any),(null as any),1,'app-booking-list',([] as any[]),(null as any),[
      [
        (null as any),
        'onPageEmit'
      ]
      ,
      [
        (null as any),
        'onBookingFilter'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import7.BookingComponent = v.component;
      if (('onPageEmit' === en)) {
        const pd_0:any = ((<any>co.onPageEmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onBookingFilter' === en)) {
        const pd_1:any = ((<any>co.getPaginatedBooking()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import10.View_BookingListComponent_0,import10.RenderType_BookingListComponent)),
    import1.ɵdid(114688,(null as any),0,import11.BookingListComponent,[
      import5.Router,
      import2.DatePipe,
      import12.BookingListMultiSelectService,
      import13.MdDialog,
      import1.ViewContainerRef,
      import14.BookingService,
      import15.SpinnerService,
      import16.NotificationServiceBus
    ]
    ,{
      bookingList: [
        0,
        'bookingList'
      ]
      ,
      p: [
        1,
        'p'
      ]
      ,
      totalItems: [
        2,
        'totalItems'
      ]

    }
    ,{
      onBookingFilter: 'onBookingFilter',
      onPageEmit: 'onPageEmit'
    }
    ),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingComponent_1)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import7.BookingComponent = v.component;
    const currVal_0:any = 'BOOKINGS';
    const currVal_1:any = false;
    ck(v,1,0,currVal_0,currVal_1);
    ck(v,6,0);
    const currVal_2:any = co.bookings;
    const currVal_3:any = co.page;
    const currVal_4:any = co.totalItems;
    ck(v,9,0,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = co.isCurrentUserInterpreter();
    ck(v,13,0,currVal_5);
  },(null as any));
}
function View_BookingComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-booking',([] as any[]),(null as any),(null as any),(null as any),View_BookingComponent_0,RenderType_BookingComponent)),
    import1.ɵdid(180224,(null as any),0,import7.BookingComponent,[
      import15.SpinnerService,
      import14.BookingService,
      import17.RolePermission,
      import12.BookingListMultiSelectService,
      import18.SubOrganisationFilterService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const BookingComponentNgFactory:import1.ComponentFactory<import7.BookingComponent> = import1.ɵccf('app-booking',import7.BookingComponent,View_BookingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking.component.ngfactory.ts